import { Link } from "react-router-dom";

export default function AccessDenied() {
  return (
    <div className="authincation h-100">
      <div className="container h-100">
        <div className="row justify-content-center h-100 align-items-center">
          <div className="col-md-6 text-center">
            <div className="error-page">
              <div className="error-inner">
                <div className="dz-error">403</div>
                <h4 className="error-head">
                  <i className="fa fa-times-circle text-danger" /> Access Denied
                </h4>
                <p>You don&apos;t have permission to view this page.</p>
                <p>Contact your administrator if you believe this is a mistake.</p>
                <Link className="btn btn-primary" to="/dashboard">
                  Back to Dashboard
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}